var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LetrType } from "@@/Letr";
import { action, makeObservable, observable } from "mobx";
export class LetrUI {
    constructor() {
        this.id = "";
        this.subject = "";
        this.tags = new Set();
        this.updatetime = 0;
        this.message = "";
        this.isExternal = false;
        this.recipients = [];
        this.isGroup = false;
        this.hasConnects = false;
        this.letrtype = LetrType.Letr;
        this.author = "";
        this.authorname = "";
        this.show = true;
        this.watermark = "";
        this.origletrid = "";
        this.readonly = false;
        makeObservable(this);
    }
    setShow(show) {
        this.show = show;
    }
    setAuthorName(name) {
        this.authorname = name;
    }
    setHasConnects(hasConnects) {
        this.hasConnects = hasConnects;
    }
    setWatermark(watermark) {
        this.watermark = watermark;
    }
    setTags(tags) {
        this.tags.clear();
        for (const t of tags) {
            this.tags.add(t);
        }
    }
    addTag(tagid) {
        this.tags.add(tagid);
    }
    removeTag(tagid) {
        this.tags.delete(tagid);
    }
    setSubject(sub) {
        this.subject = sub;
    }
    setLastmessage(message) {
        this.message = message;
    }
    setUpdateTime(time) {
        this.updatetime = time;
    }
    setExternal(isExternal) {
        this.isExternal = isExternal;
    }
    setRecepient(recipients) {
        this.recipients = recipients;
    }
    setIsGroup(isGroup) {
        this.isGroup = isGroup;
    }
    setLetrType(type) {
        this.letrtype = type;
    }
    setAuthor(author) {
        this.author = author;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrUI.prototype, "subject", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], LetrUI.prototype, "tags", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrUI.prototype, "updatetime", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrUI.prototype, "message", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrUI.prototype, "isExternal", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], LetrUI.prototype, "recipients", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrUI.prototype, "isGroup", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrUI.prototype, "hasConnects", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], LetrUI.prototype, "letrtype", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], LetrUI.prototype, "author", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], LetrUI.prototype, "authorname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrUI.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrUI.prototype, "watermark", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrUI.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrUI.prototype, "setAuthorName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrUI.prototype, "setHasConnects", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrUI.prototype, "setWatermark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], LetrUI.prototype, "setTags", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrUI.prototype, "addTag", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrUI.prototype, "removeTag", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrUI.prototype, "setSubject", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrUI.prototype, "setLastmessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], LetrUI.prototype, "setUpdateTime", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrUI.prototype, "setExternal", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], LetrUI.prototype, "setRecepient", null);
